import tw from 'twin.macro';

import { Modal } from '@/components/base';
import { GetJobPositionsQuery } from '@/libs/graphql';

type JobPosition = GetJobPositionsQuery['getJobPositions'][number];

type Props = {
  position: JobPosition;
  loading?: boolean;
  errorMessage?: string;
  onConfirm: () => void;
  onClose: () => void;
};

const DeletePositionModal = ({ position, loading, errorMessage, onConfirm, onClose }: Props) => {
  return (
    <Modal
      title="ลบตำแหน่งงาน"
      description={
        <>
          <p tw="text-gray-500">
            {`คุณต้องการลบตำแหน่ง "${position.title}" ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้`}
          </p>
          {errorMessage && <p tw="mt-2 text-red-600">{errorMessage}</p>}
        </>
      }
      primaryButtonText="ลบ"
      primaryButtonAction={onConfirm}
      secondaryButtonText="ยกเลิก"
      secondaryButtonAction={onClose}
      loading={loading}
    />
  );
};

export default DeletePositionModal;
